import { allLocales } from "../core/i18n/locale-codes.js";
import { localeToCurrencyMapping, supportedCurrencies, } from "../core/currency/constants.js";
import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from "../views/constants.js";
/**
 * Pick the supported locale for a visitor: the browser's languages in
 * preference order, then the given fallbacks, then the default. A candidate
 * matches a supported locale exactly, or by language alone (so `de` and
 * `pt-BR` resolve to `de-DE` and `pt-PT`). The first hit wins.
 */
export function getLocale(fallbackLocale) {
    const browserLanguages = typeof navigator === "undefined"
        ? []
        : navigator.languages?.length
            ? navigator.languages
            : [navigator.language];
    const fallbacks = Array.isArray(fallbackLocale)
        ? fallbackLocale
        : fallbackLocale
            ? [fallbackLocale]
            : [];
    for (const candidate of [...browserLanguages, ...fallbacks]) {
        const match = matchSupportedLocale(candidate);
        if (match)
            return match;
    }
    return DEFAULT_LOCALE;
}
function matchSupportedLocale(candidate) {
    if (typeof candidate !== "string")
        return undefined;
    const wanted = candidate.trim().replace(/_/g, "-").toLowerCase();
    if (!wanted)
        return undefined;
    const exact = allLocales.find((locale) => locale.toLowerCase() === wanted);
    if (exact)
        return exact;
    const language = wanted.split("-")[0];
    return allLocales.find((locale) => locale.split("-")[0] === language);
}
export function isLocaleSupported(locale) {
    return allLocales.includes(locale);
}
export const getCurrency = (locale) => {
    return (localeToCurrencyMapping[locale] || DEFAULT_CURRENCY);
};
export function isCurrencySupported(currency) {
    return supportedCurrencies.includes(currency?.toUpperCase());
}
export { getTextDirection } from "../core/utils/locale.js";
